// 
//   cd  D:\2026_projects\vrworld\manage
//   npm run build 
//   ftp로 build 폴더아래에 있는 파일을 업로드 한다.


//import { gapi } from 'gapi-script';  
//import useDrivePicker from 'react-google-drive-picker'
//npm install --save @types/gapi
//npm install --save @types/gapi.auth2
//import cors from 'cors';
import React, { Suspense, useState,useRef, useEffect,useCallback, useReducer,useInsertionEffect } from 'react';
import './reset.css';
import './App.css';
import { useContext } from 'react';
import axios from 'axios';
import AFRAME from 'aframe';
import { relative } from 'path';
//import {fs} from 'fs'
//import * as fs from 'fs';
//const fs = require('fs');

var keyCount=1;
var access_token='none';
var cloudCurrentFolder='/';
var lastClickedItemNum = -1;//LeftPane의 최후 선택한 항목(특별 컬러)
var lastClickMode='none';//RightPane의 최후 선택 모드
var isWebCameraOn= false;
var isVideoBrodcast=false;
var isAudioBrodcast=false;
var homescreen_url='/images/home.jpg';
var g_leftwingPlayCard:any;

const CenterPaneVRWorld = React.lazy(() => import('./CenterPaneVRWorld'));
axios.defaults.withCredentials = true;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function aTagClick(setMessage:any, para1:any, para2:any,para3:any, access_token:any, ownerID:any='none'){
  //통상 자신의 폴더에서 파일을 읽는 경우에서 ownerID='none' 인데
  // 타인의 폴더(member/public)인 경우 none이 아닌 소유자의 user_id 를 전달 받는다. 
  if(!access_token) {
    //console.log("access_token is not available");
    access_token={"access_token":"none"};}
    setMessage( { para1:para1, para2:para2, para3:para3, access_token:access_token,para4:ownerID} );   //call setMessage() It is useState Hook function
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const userData = {
  playlist:"",
  centerDisplay: "playlist",
  leftDisplay: "playlist",
  isLoading: false,
  message:{para1:"",para2:"",para3:"",access_token:""},
  webCamMessage:{para1:"",para2:"",para3:"",access_token:""},
  generalMessage:{mcode:"nocode",moperand:"none"},
  connectedUser:[],
  count:1
};
const UserContext = React.createContext(userData);


function LeftPaneItemTitle(props:any){
     return(
        <h1 style={{margin:'2px'}}>{props.text}</h1>
     );
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// eslint-disable-next-line react-hooks/rules-of-hooks
function LeftPaneItemCommunity(props:any){ //LeftPaneCommunityPlaylist에서 사용한다. 
  //setGeneralMessage={props.setGeneralMessage}
  const normal={border:'2px solid gray'};
  const over={border:'2px solid blue'};
  const [boardcolor, setColor]= useState(normal);
  const styleClass:any= useRef('LeftPaneButton');
  var imgsrc='/images/'+props.jsonData.type+'.png';
  //const [styleClass, setStyleClass]= useState('LeftPaneButton');
  //var styleClass=props.cname;
  
  if(lastClickedItemNum===props.indexCount) styleClass.current='LeftPaneButtonClicked';else styleClass.current='LeftPaneButton';
  //console.log('styleClass=',styleClass.current);
  const [refresh, setRefresh] = useState({refresh:false});//local refresh!!

  function makeRefresh()
  {
    if(refresh.refresh) setRefresh({refresh:false});
    else  setRefresh({refresh:true});
  }

  document.addEventListener("refreshLeftPaneItemCommunity", function(event) { 
    event.preventDefault();
    makeRefresh();
    //console.log('custom Event=',event); 
 });

  return(
     <div>
      <button className={styleClass.current} style={boardcolor} 
       onMouseEnter={()=>{setColor(over);if(lastClickedItemNum===props.indexCount) styleClass.current='LeftPaneButtonClicked';else styleClass.current='LeftPaneButton'; makeRefresh();}}
       onMouseLeave={()=>{setColor(normal);if(lastClickedItemNum===props.indexCount) styleClass.current='LeftPaneButtonClicked';else styleClass.current='LeftPaneButton';makeRefresh();}}
       onClick={()=>{
            lastClickedItemNum = props.indexCount;
            aTagClick(props.setMessage, props.jsonData.type, props.jsonData.url,props.jsonData.info, access_token,props.ownerID);//props.ownerID추가
            makeRefresh();
             props.renewRefresh();
             document.dispatchEvent(new Event('refreshLeftPaneItemCommunity', {
              cancelable: true
               //detail: { key1: "createPlaylist", key2:"none" }
             }));            
            }}>

      <img src={ imgsrc} alt="type" height="100%" style={{alignSelf:'left',margin:"0px",position:"absolute", left:"0px", top:"0px"  }} />
           &nbsp;&nbsp;&nbsp;&nbsp;{props.jsonData.subtitle}
      </button>
     </div>
  );
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function LeftPaneCommunityPlaylist(props:any){ //이곳은 playlist 생성 편집 저장 기능이 없다.
  //console.log('>>>LeftPane()...');
  const htmlArry:any= useRef([]);
  const themeRef:any= useRef({});
  const [refresh, setRefresh] = useState( {refresh:false} );
//  const [modePlayList, setModePlaylist] = useState('normal');//normal edit
  var fileUrl="";
  var ownerID="none";

  //console.log('LeftPaneCommunityPlaylist props.Playlist=',props.Playlist);
  //console.log('LeftPaneCommunityPlaylist props.Playlist=',props.Playlist);
  //console.log('LeftPaneCommunityPlaylist props.Playlist=',props.Playlist);

  document.addEventListener("creatPlaylist", function(event) { 
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
      //console.log('custom Event=',event); 
});

  useEffect(() => {
    //console.log('useEffect #1');
    getContentJSONData(renewRefresh);
  }, []); 

  useEffect(() => {
    //console.log('useEffect #2');
    getContentJSONData(renewRefresh);
  }, [props.Playlist]);// modePlayList

  //decodeURI() <==> encodeURI() 
  
  try{
    fileUrl= props.Playlist.playlistFilename;
    ownerID= props.Playlist.OwnerID;
    //console.log('LeftPanePlaylist fileUrl=',fileUrl,' ownerID=',ownerID); 

    if(fileUrl===undefined) fileUrl="";
    if(ownerID===undefined) ownerID="none";
  } catch(e:any){
     themeRef.current= [{"title":"no title","items":[]}];
  }

  function renewRefresh(){
       //console.log('renewRefresh... before refresh=',refresh.refresh);
       if(refresh.refresh) setRefresh( {refresh:false} );
       else setRefresh( {refresh:true} );
      // console.log('renewRefresh... aftere refresh=',refresh.refresh);
  }

  function makeHtmlArray(theme:any,renewRefresh:any){
     //console.log('makeHtmlArray()...',themeRef.current);
     var indexCount=0;
     
      htmlArry.current=[];
      themeRef.current=theme;
      if(Array.isArray(theme)) {
        theme.forEach(function(key1:any, index1:any, array1:any)
        {
              keyCount=keyCount+1;   
              //console.log('>>key1.title=',key1.title);
              htmlArry.current.push( <br key={keyCount}/>);
              keyCount=keyCount+1;   
                  htmlArry.current.push( <LeftPaneItemTitle key={keyCount} cname="title" text={key1.title} />);
              keyCount=keyCount+1;   

              ///check!!!!!!!!!!!
              key1.items.forEach(function(key2:any,index2:any,array2:any){
                      //console.log('key2=',key2);
                          htmlArry.current.push(<LeftPaneItemCommunity key={keyCount} cname="LeftPaneButton" jsonData={key2} ownerID={ownerID} setGeneralMessage={props.setGeneralMessage} setMessage={props.setMessage} indexCount={indexCount} renewRefresh={renewRefresh} />);
                          indexCount=indexCount+1;
                      keyCount=keyCount+1;   
              });

        }); 

        keyCount=keyCount+1;   
        //console.log('makeHtmlArray refresh!!!!');
        renewRefresh();
        props.onDraw();//redraw all
      } //if(theme)
    }

  var getContentJSONData = async (renewRefresh:any)=>{
    if(fileUrl.length<3) {
        themeRef.current= [{"title":"no title","items":[]}];
        return;
    }
     htmlArry.current=[];
     //console.log('getContentJSONData token=',props.access_token);

     await axios.post('readPlaylist',
      {url:fileUrl,ownerID:ownerID},
      {headers: {
        'Authorization': `Bearer ${props.access_token}`, // 토큰을 Bearer 토큰으로 추가
        'Content-Type': 'application/json', // 필요한 경우 Content-Type 설정
      }}
      )
     .then( (response:any)=>{ 
        //console.log('response=',response);
        var { data : {theme} } = response;//JSON.parse(theme);
        g_leftwingPlayCard={theme:theme, ownerID:ownerID}
        themeRef.current= theme;
        makeHtmlArray(themeRef.current,renewRefresh);
      });
  };
  

  let title=fileUrl.replace(/\.[^/.]+$/, ""); //  props.Playlist.replace(/\.[^/.]+$/, "")
  title=decodeURI(title);

  return(
    <div className="LeftPane">
       <div className="LeftHideShowButton">
          <br/><h1 style={{margin: "2px"}}>{title} </h1>
       </div>
       <div >
          <br/><br/>
          { htmlArry.current}
       </div>
    </div>
 ) 
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function LoadingSpinner() {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
}
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//catagory title for Edit
function LeftPaneItemTitleEdit(props:any){

  function deleteFromTitle(theme:any, subtheme:any)
  {
     //console.log('deleteLeftPaneItem()...',title);
     for (var i = 0; i < theme.length; ++i) {
      try{
         var obj = theme[i];
         if (obj ===subtheme) {
             delete theme[i];
             break;
        }
      } catch(e:any){
      }
     }
     theme = theme.filter(function(x:any) { return x !== null }); 
     //console.log('deleteLeftPaneItem()  theme>>>>=',theme);
  }

  return(
     <div className={props.cname}>
      <input type="text" defaultValue={props.jsonData.title}  className="LeftPaneEditInput"
          onChange={(e)=>{  
            //console.log('#1 onChnage()... props.jsonData.title='+props.jsonData.title+' new text='+  e.target.value);
            props.jsonData.title= e.target.value;
          }}
     
       />&nbsp;&nbsp;&nbsp;&nbsp;
          <button className="LeftPaneTitleButtonDel">
              <button className="LeftPaneTitleImgDel"
                 onClick={()=>{
                    //console.log('click image...');
                     deleteFromTitle(props.theme, props.jsonData);
                     props.makeHtmlArray(props.theme);
                    }}>
                 <img src="/images/del.png" alt="del"  className="LeftPaneTitleImgDel" />
               </button>
          </button>
     </div>
  );
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function LeftPaneItemNormal(props:any){
  
      const normal={border:'2px solid gray'};
      const over={border:'2px solid blue'};
      const [boardcolor, setColor]= useState(normal);
      const styleClass:any= useRef('LeftPaneButton');
      var imgsrc='/images/'+props.jsonData.type+'.png';
      //const [styleClass, setStyleClass]= useState('LeftPaneButton');
      //var styleClass=props.cname;
      
      if(lastClickedItemNum===props.indexCount) styleClass.current='LeftPaneButtonClicked';else styleClass.current='LeftPaneButton';


      //console.log('styleClass=',styleClass.current);
      const [refresh, setRefresh] = useState({refresh:false});//local refresh!!

      function makeRefresh()
      {
        if(refresh.refresh) setRefresh({refresh:false});
        else  setRefresh({refresh:true});
      }

      document.addEventListener("refreshLeftPaneItemNormal", function(event) { 
        event.preventDefault();
        makeRefresh();
        //console.log('custom Event=',event); 
    });

  return(
     <div>
      <button className={styleClass.current} style={boardcolor} 
       onMouseEnter={()=>{setColor(over);if(lastClickedItemNum===props.indexCount) styleClass.current='LeftPaneButtonClicked';else styleClass.current='LeftPaneButton'; makeRefresh();}}
       onMouseLeave={()=>{setColor(normal);if(lastClickedItemNum===props.indexCount) styleClass.current='LeftPaneButtonClicked';else styleClass.current='LeftPaneButton';makeRefresh();}}
       onClick={()=>{
            lastClickedItemNum = props.indexCount;
            //console.log('LeftPaneItemNormal click!!! indexCount=',props.indexCount,' lastClickedItemNum=',lastClickedItemNum);
            //props.jsonData={"subtitle": "부석사.png","type": "photo360","url": "/resources/고려시대/부석사.png","info": "1.0 1.0 1.0"}
            //console.log('props.setMessage=',props.setMessage,' props.jsonData=',props.jsonData);
            aTagClick(props.setMessage, props.jsonData.type, props.jsonData.url,props.jsonData.info, access_token);

            makeRefresh();
             props.renewRefresh();
             document.dispatchEvent(new Event('refreshLeftPaneItemNormal', {
              cancelable: true
               //detail: { key1: "createPlaylist", key2:"none" }
             }));            
            }}>

      <img src={ imgsrc} alt="type" height="100%" style={{alignSelf:'left',margin:"0px",position:"absolute", left:"0px", top:"0px"  }} />
           &nbsp;&nbsp;&nbsp;&nbsp;{props.jsonData.subtitle}
      </button>
     </div>
  );
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function LeftPaneItemEdit(props:any){
  
//  const datatype:any= useRef('photo');
  const [refresh, setRefresh] = useState({refresh:true});//local refresh!!
  const dispText:any= useRef(props.text);

  useEffect(() => {
   // console.log('useEffect ###1');
  }, [dispText.current]);//redraw!!!

  function deleteFromSubtitle(orgintheme:any, jsonSubPart:any)
  {
     //console.log('deleteFromSubtitle()...jsonSubPart=',jsonSubPart);
     for (var i = 0; i < orgintheme.length; ++i) {
      try{
         var obj = orgintheme[i];
         //console.log('obj',obj);
         for (var j = 0; j < obj.items.length; ++j) {
              let subObj= obj.items[j];
              if(subObj===jsonSubPart){
                 //console.log('find and delete from array=>',subObj);
                 obj.items.splice(j, 1);
                 break;
              }
         }
      }
      catch(e:any){}  
     }
     //console.log('after processing theme=',orgintheme);
  }
  
  var imgsrc='/images/'+props.jsonData.type+'.png';
  //console.log('props.jsonData=',props.jsonData);
  //console.log('imgsrc=',imgsrc);
  return(
   <div>  
       <button className={props.cname} style={{position:"relative"}} >
        {false && <img src="/images/dot3.png" alt="type" height="100%" style={{position:"absolute", left:"0px", top:"0px"}} 
              onClick={()=>{
                /*  //playlist에서 TYPE을  추가로 변경하는 것도 나쁘진 않을텐데??
                console.log('>>>LeftPaneItem에서 Dot3 이미지 Click!!!>>>>');
                if(props.jsonData.type===undefined) props.jsonData.type='photo'; 
                if(props.jsonData.type==='photo') props.jsonData.type='photo360';
                else if(props.jsonData.type==='photo360') props.jsonData.type='video';
                else if(props.jsonData.type==='video') props.jsonData.type='video360';
                else if(props.jsonData.type==='video360') props.jsonData.type='photo3D';
                else if(props.jsonData.type==='photo3D') props.jsonData.type='photo3D180';
                else if(props.jsonData.type==='photo3D180') props.jsonData.type='photo3D360';
                else if(props.jsonData.type==='photo3D360') props.jsonData.type='video3D';
                else if(props.jsonData.type==='video3D') props.jsonData.type='video3D180';
                else if(props.jsonData.type==='video3D180') props.jsonData.type='video3D360';
                else if(props.jsonData.type==='video3D360') props.jsonData.type='model';
                else if(props.jsonData.type==='model') props.jsonData.type='unknown';
                else if(props.jsonData.type==='unknown') props.jsonData.type='photo';
                if(refresh.refresh) setRefresh({refresh:false});
                else  setRefresh({refresh:true});
                */
               }}/> }
          <img src={ imgsrc} alt="type" height="100%" style={{alignSelf:'left',margin:"0px",position:"absolute", left:"7px", top:"0px"  }} />
          <input type="text" defaultValue={props.jsonData.subtitle}  className="LeftPaneEditInput"   autoComplete="none" height="100%" width="80%" style={{textAlign:"center", alignItems:"center"}}
            onChange={ (e)=>{  
                //console.log('#2 onChnage() props.jsonData.text='+props.text+' new text='+  e.target.value);
                props.jsonData.subtitle= e.target.value;
          }} />
         <img src="/images/del.png" alt="del" className="LeftPaneButtonDel" 
            onClick={()=>{ //delete Key!!!
                  //console.log('>>>LeftPaneItemEdit delete >>>>',props.jsonData.subtitle);
                  deleteFromSubtitle(props.theme, props.jsonData);
                  props.makeHtmlArray(props.theme, props.renewRefresh);
              }
            }
         />
       </button>
  </div>
  );
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function LeftPanePlaylist(props:any){
  //console.log('>>>LeftPane()...');
  const htmlArry:any= useRef([]);
  const themeRef:any= useRef({});
  const [refresh, setRefresh] = useState( {refresh:false} );
  const [modePlayList, setModePlaylist] = useState('normal');//normal edit
  var fileUrl="";
  var ownerID="none";

  //console.log('LeftPanePlaylist props.Playlist=',props.Playlist);
  document.addEventListener("creatPlaylist", function(event) { 
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
      //console.log('custom Event=',event); 
      setModePlaylist('edit');
      createPlaylist();
});

  useEffect(() => {
    //console.log('useEffect #1');
    getContentJSONData(renewRefresh);
  }, []); 

  useEffect(() => {
    //console.log('useEffect #2');
    getContentJSONData(renewRefresh);
  }, [props.Playlist, modePlayList]);

  //decodeURI() <==> encodeURI() 
  
  try{
    //console.log('LeftPanePlaylist props.Playlist=',props.Playlist);
    fileUrl= props.Playlist.playlistFilename;
    ownerID= props.Playlist.OwnerID;
    //console.log('LeftPanePlaylist fileUrl=',fileUrl,' ownerID=',ownerID); 

    if(fileUrl===undefined) fileUrl="";
    if(ownerID===undefined) ownerID="none";
  } catch(e:any){
     themeRef.current= [{"title":"no title","items":[]}];
  }



  function createPlaylist(){
    setModePlaylist('edit');
    let fname = prompt("Please enter file name", "playlist01");
    if (fname===null) fname="playlist01";
    fname=encodeURI(fname+'.json');
    //console.log('createPlaylist  filename.current=',fname); 
    setModePlaylist('edit');
    //props.setPlaylist(fname);
    var strVar= `{"playlistFilename":"${fname}","OwnerID":"none"}`;//ownerID를 추가한다.
    props.setPlaylist(JSON.parse(strVar));
  }

  function renewRefresh(){
       //console.log('renewRefresh... before refresh=',refresh.refresh);
       if(refresh.refresh) setRefresh( {refresh:false} );
       else setRefresh( {refresh:true} );
      // console.log('renewRefresh... aftere refresh=',refresh.refresh);
  }

  function appendFromTitle(theme:any, title:any, json:any)
  {
     for (var i = 0; i < theme.length; ++i) {
      try{
         var obj = theme[i];
         if (obj.title ===title) {
            obj.items.push(json);
           break;
        }
      } catch(e:any){
      }
     }
     theme = theme.filter(function(x:any) { return x !== null }); 
  }

  function makeHtmlArray(theme:any,renewRefresh:any){
     //console.log('makeHtmlArray()...',themeRef.current);
      
      htmlArry.current=[];
      themeRef.current=theme;
      var indexCount=0;
      if(Array.isArray(theme)) {
        theme.forEach(function(key1:any, index1:any, array1:any)
        {
              keyCount=keyCount+1;   
              //console.log('>>key1.title=',key1.title);
              htmlArry.current.push( <br key={keyCount}/>);
              keyCount=keyCount+1;   
              if(modePlayList==="normal"){
                  htmlArry.current.push( <LeftPaneItemTitle key={keyCount} cname="title" text={key1.title} />);
              } else{ 
                //edit mode
                htmlArry.current.push( <LeftPaneItemTitleEdit key={keyCount} cname="title" jsonData={key1}  makeHtmlArray={makeHtmlArray} theme={themeRef.current}/>);
              }
              keyCount=keyCount+1;   

              ///check!!!!!!!!!!!
              key1.items.forEach(function(key2:any,index2:any,array2:any){
                      //console.log('key2=',key2);
                      if(modePlayList==="normal"){
                          htmlArry.current.push(<LeftPaneItemNormal key={keyCount} cname="LeftPaneButton" jsonData={key2} setMessage={props.setMessage} indexCount={indexCount} renewRefresh={renewRefresh} />);
                          indexCount=indexCount+1;
                      } else {
                        //edit mode <<---
                        htmlArry.current.push(
                           <LeftPaneItemEdit key={keyCount} cname="LeftPaneButtonEdit" jsonSubPart={key1} jsonData={key2}  makeHtmlArray={makeHtmlArray} theme={themeRef.current} renewRefresh={renewRefresh} />
                        );
                      }
                      keyCount=keyCount+1;   
              });

              if(modePlayList==="edit") {// drop area 설정
                  keyCount=keyCount+1;   
                  htmlArry.current.push(
                    <div key={keyCount} className="LeftPaneDropZone"  
                      onDrop={(e:any)=>{
                        //console.log('onDrop e=',e);
                        let info=e.dataTransfer.getData('info');
                        const infoArray = info.split(',');
                        let filename= infoArray[0];
                        //if(filename.indexOf('/')===0) filename=filename.slice(1);// 맨앞에 / 있으면 제거 한다. 
                        //console.log('filename=',filename);
                        //console.log('infoArray=',infoArray);     
                        
                        let jsonStr='';
                        if(cloudCurrentFolder==='/') jsonStr='{"subtitle":"'+infoArray[2]+'","type":"'+ infoArray[1]+'", "url":"/resources'+cloudCurrentFolder+filename+'","info":"'+infoArray[3]+'"}';
                        else jsonStr='{"subtitle":"'+infoArray[2]+'","type":"'+ infoArray[1]+'", "url":"/resources'+cloudCurrentFolder+'/'+filename+'","info":"'+infoArray[3]+'"}';
                        appendFromTitle(theme, key1.title,JSON.parse(jsonStr) );
                        makeHtmlArray(theme,renewRefresh);
                      }}
                      
                      onDragOver={(e:any)=>{
                          let event = e as Event;
                          event.stopPropagation();
                          event.preventDefault();
                        }
                    } >Drop Here from Media Library</div>
                  );
              }
        }); 

        keyCount=keyCount+1;   
        if(modePlayList==="edit"){ htmlArry.current.push(
               <button key={keyCount} className="LeftPaneButtonHalf"
                   onClick={()=>{ //add new title
                      theme.push(JSON.parse( '{ "title":"no title","items":[]}')); 
                      //console.log('add new click', theme);
                      makeHtmlArray(theme,renewRefresh);
                   }} 
               > Add New Title</button>);}
        //console.log('makeHtmlArray refresh!!!!');
        renewRefresh();
        props.onDraw();//redraw all
      } //if(theme)
    }

  var getContentJSONData = async (renewRefresh:any)=>{
    //console.log('getContentJSONData()==>>> read json playlist from ',props.Playlist);
    if(fileUrl.length<3) {
        themeRef.current= [{"title":"no title","items":[]}];
        return;
    }
     htmlArry.current=[];
     //console.log('props.Playlist=',props.Playlist);
     //console.log('getContentJSONData fileUrl=',fileUrl,' ownerID=',ownerID); 

     await axios.post('readPlaylist', {url:fileUrl,ownerID:ownerID})
     .then( (response:any)=>{ 
        //console.log('response=',response);
        var { data : {theme} } = response;//JSON.parse(theme);
        //console.log('theme=',theme);
        g_leftwingPlayCard={theme:theme, ownerID:ownerID}
        themeRef.current= theme;
        makeHtmlArray(themeRef.current,renewRefresh);
      });
  };
  let title=fileUrl.replace(/\.[^/.]+$/, ""); //  props.Playlist.replace(/\.[^/.]+$/, "")
  title=decodeURI(title);
  return(
    <div className="LeftPane">
       <div className="LeftHideShowButton">
          <br/>
          <h1 style={{margin: "2px"}}>{title} </h1>
          {/* <button className="ThreeButtons" onClick={()=>{ createPlaylist(); setModePlaylist("edit");}}>Create</button> */}
          {modePlayList==="normal"?
                   <button className="TwoButtons" onClick={()=>{ setModePlaylist("edit");}}>Edit</button>
               :
                  <button className="TwoButtons" onClick={()=>{ setModePlaylist("normal");}}>Discard</button>
          }
          <button className="TwoButtons"onClick={()=>{
               // edit 모드에서만 save 할 수 있다. 
               if(modePlayList !== 'edit') return;
              const results = themeRef.current.filter( (element:any) => {   //delete empty elements
                return element !== '';
              });

             var new_theme={ "theme":results};//make to new format!!
              var str= JSON.stringify(new_theme,null,4);//json -> string
            
              setModePlaylist('now_uploading');

              uploadPlaylist(setModePlaylist,setRefresh,refresh);//call server side program
              async function uploadPlaylist(setModePlaylist:any,setRefresh:any,refresh:any){
                await axios.post('uploadPlaylist', {url:props.Playlist, json:str}) 
                .then( (ret_data:any)=>{ 
                       //업로드가 완료된 이시점에서 모드를 전환하고 refresh를 하여야 하는데 잘 동작을 않한다. 
                       //그래서 setTimeout()을 사용하였음....ㅠㅠ
                    });
              }
              setTimeout(()=>{setModePlaylist('normal');}, 300);//upload 이후 refresh!!!
          }}>Save</button>
       </div>
       <div >
          <br/><br/>
          { modePlayList==='now_uploading'  &&  <LoadingSpinner /> }
          { modePlayList!=='now_uploading'  && htmlArry.current}
        </div>
    </div>
 ) 
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function CenterPaneMemberManage(props:any){
  const   style = useRef('CenterPane');
  const [joinUserID, setJoinUserID] = useState('');
  const [subscribedMeMembers, setSubscribedMeMembers] = useState({member: [{ userID: "", userName: "" }]});
  const [appliedMembers, setAppliedMembers] = useState({member: [{ userID: "", userName: "" }]});
  const [joinedMembers, setJoinedMembers] = useState({member: [{ userID: "", userName: "" }]});
  const [refresh, setRefresh] = useState(false);

  useEffect(()=>{
    getSubscribedMembers();
    getAppliedMembers();
    getJoinedMembers();
 },[]);

 useEffect(()=>{
     getSubscribedMembers();
     getAppliedMembers();
     getJoinedMembers();
  },[refresh]);

  /*
  const subscribedMembers = {
    member: [
      { userID: "Peter110", userName: "Griffin Peter" },
      { userID: "Lios220", userName: "Griffin Lios" },
      { userID: "Joe330", userName: "Swanson Joe" },
      { userID: "Cleveland333", userName: "Brown Cleveland" }
    ]
  };
  const appliedMembers = {
    member: [
      { userID: "Peter110", userName: "Griffin Peter" },
      { userID: "Lios220", userName: "Griffin Lios" },
      { userID: "Joe330", userName: "Swanson Joe" },
      { userID: "Cleveland333", userName: "Brown Cleveland" }
    ]
  };
  const joinedMembers = {
    member: [
      { userID: "Peter110", userName: "Griffin Peter" },
      { userID: "Lios220", userName: "Griffin Lios" },
      { userID: "Joe330", userName: "Swanson Joe" },
      { userID: "Cleveland333", userName: "Brown Cleveland" }
    ]
  };
*/

  const handleSubscribe = () => {
    let user_id=sessionStorage.getItem("user_id");
    //console.log('Uploading data: user_id=',user_id,' subscribe to ', joinUserID);
    subscribeMember(joinUserID);
    alert('Subscribe request sent to the user!');
    setJoinUserID('');
  };

  async function subscribedMeMembers_cancel(user_id:any,member_user_id:any){
        await axios({
          url: '/subscribedMeMembers_cancel',// url 앞에 '/'를 안붙이면 /manage/getCommunityPlaylist를 호출한다.
          method: 'POST',
          data: {
            user_id: ''+user_id,
            member_user_id:''+member_user_id
          },
          responseType: 'json'
        })
        .then( (ret_data:any)=>{ 
          //console.log(ret_data.data);
          setRefresh(!refresh);
        });
  }
  async function appliedMembers_accept(user_id:any,member_user_id:any){
        await axios({
          url: '/appliedMembers_accept',// url 앞에 '/'를 안붙이면 /manage/getCommunityPlaylist를 호출한다.
          method: 'POST',
          data: {
            user_id: ''+user_id,
            member_user_id:''+member_user_id
          },
          responseType: 'json'
        })
        .then( (ret_data:any)=>{ 
          //console.log(ret_data.data)
          setRefresh(!refresh);
        });
  }

  async function appliedMembers_delete(user_id:any,member_user_id:any){
    await axios({
      url: '/appliedMembers_delete',// url 앞에 '/'를 안붙이면 /manage/getCommunityPlaylist를 호출한다.
      method: 'POST',
      data: {
        user_id: ''+user_id,
        member_user_id:''+member_user_id
  },
      responseType: 'json'
    })
    .then( (ret_data:any)=>{ 
      //console.log(ret_data.data)
      setRefresh(!refresh);
    });

  }
  async function joinedMembers_delete(user_id:any,member_user_id:any){
    await axios({
      url: '/joinedMembers_delete',// url 앞에 '/'를 안붙이면 /manage/getCommunityPlaylist를 호출한다.
      method: 'POST',
      data: {
        user_id: ''+user_id,
        member_user_id:''+member_user_id
    },
      responseType: 'json'
    })
    .then( (ret_data:any)=>{ 
      //console.log(ret_data.data)
      setRefresh(!refresh);
    });
  }

  async function subscribeMember(member_id:any){
    let user_id=sessionStorage.getItem("user_id");
    //console.log('subscribeMember user_id=',user_id,' member_id=',member_id);
    if(user_id===member_id) return;
    await axios({
      url: '/subscribeMember',// url 앞에 '/'를 안붙이면 /manage/getCommunityPlaylist를 호출한다.
      method: 'POST',
      data: {
        user_id: ''+user_id,
        member_user_id: member_id
      },
      responseType: 'json'
    })
    .then( (ret_data:any)=>{ 
      //console.log(ret_data.data)
    });
  }

  async function getSubscribedMembers(){
    let user_id=sessionStorage.getItem("user_id");
    await axios({
      url: '/getSubscribedMembers',// url 앞에 '/'를 안붙이면 /manage/getCommunityPlaylist를 호출한다.
      method: 'POST',
      data: {
        user_id: ''+user_id
      },
      responseType: 'json'
    })
    .then( (ret_data:any)=>{ 
       //console.log(ret_data)
       setSubscribedMeMembers(ret_data.data);
    });
  }

  async function getAppliedMembers(){
    let user_id=sessionStorage.getItem("user_id");
    await axios({
      url: '/getAppliedMembers',// url 앞에 '/'를 안붙이면 /manage/getCommunityPlaylist를 호출한다.
      method: 'POST',
      data: {
        user_id: ''+user_id
      },
      responseType: 'json'
    })
    .then( (ret_data:any)=>{ 
      //console.log(ret_data)
       setAppliedMembers(ret_data.data);
    });
  }

  async function getJoinedMembers(){
    let user_id=sessionStorage.getItem("user_id");
    await axios({
      url: '/getJoinedMembers',// url 앞에 '/'를 안붙이면 /manage/getCommunityPlaylist를 호출한다.
      method: 'POST',
      data: {
        user_id: ''+user_id
      },
      responseType: 'json'
    })
    .then( (ret_data:any)=>{ 
      // console.log(ret_data)
       setJoinedMembers(ret_data.data);
    });
  }


  return (
    <div className={style.current}>
      <br />
      <h1 style={{ color: 'blue' }}>&nbsp;&nbsp;Subscribe to Member</h1><br/>
      <table style={{ marginLeft: '10px' }}>
        <tbody>
          <tr style={{ color: 'gray' }}>
            <th>User ID</th>
            <th>Submit</th>
          </tr>
          <tr>
             <th>
                 <input  type="text" placeholder="User ID"  value={joinUserID} onChange={(e) => setJoinUserID(e.target.value)}  />
             </th>
             <th>
                   <button onClick={handleSubscribe}>Requst</button>
             </th>
          </tr>
        </tbody>
      </table>

      <br /><br /><br />
      <h1 style={{ color: 'blue' }}>&nbsp;&nbsp;Subscribed Members</h1><br/>
       <table style={{ marginLeft: '10px' }}>
        <tbody>
          <tr style={{ color: 'gray' }}>
            <th>User Name</th>
            <th>Cancel</th>
          </tr>
          {subscribedMeMembers.member.map((member, index) => (
            <tr key={index}>
              <td>{member.userName}</td>
              <td>
              {member.userID!=='' && <button onClick={() => {
                  //console.log('Cancel button click ',member.userID, member.userName);
                  let user_id=sessionStorage.getItem("user_id");
                  subscribedMeMembers_cancel(user_id,member.userID);
                }}>Cancel Subscribe</button>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      
      <br /><br /><br />
      <h1 style={{ color: 'blue' }}>&nbsp;&nbsp;Members who applied to my account</h1><br/>
      <table style={{ marginLeft: '10px' }}>
        <tbody>
          <tr style={{ color: 'gray' }}>
            <th>User Name</th>
            <th>Accept</th>
            <th>Delete</th>
          </tr>
          {appliedMembers.member.map((member, index) => (
            <tr key={index}>
              <td>{member.userName}</td>
              <td>
              {member.userID!=='' && <button onClick={() => {
                  //console.log('Accept button click ',member.userID,member.userName);
                  let user_id=sessionStorage.getItem("user_id");
                  appliedMembers_accept(user_id,member.userID);
                }}>Accept</button>}
              </td>
              <td>
              {member.userID!=='' &&<button onClick={() => {
                  //console.log('Accept button click ',member.userID,member.userName);
                  let user_id=sessionStorage.getItem("user_id");
                  appliedMembers_delete(user_id,member.userID);
                }}>Delete</button>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <br /><br /><br />
      <h1 style={{ color: 'blue' }}>&nbsp;&nbsp;Members who joined to my account</h1><br/>
      <table style={{ marginLeft: '10px' }}>
        <tbody>
          <tr style={{ color: 'gray' }}>
            <th>User Name</th>
            <th>Delete</th>
          </tr>
          {joinedMembers.member.map((member, index) => (
            <tr key={index}>
              <td>{member.userName}</td>
              <td>
                {member.userID!=='' && <button onClick={() => {
                 //console.log('Delete button click ',member.userID,member.userName);
                  let user_id=sessionStorage.getItem("user_id");
                  joinedMembers_delete(user_id,member.userID);
                }}>Delete</button>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function CenterPanePlaylistMember(props:any){ //get member only playlist
  //2단계로 정보를 가져온다 member_step1, member_step2
  const   filenames:any= useRef([]);
  const   joinedNames:any= useRef([]);
  const   htmlArry:any= useRef([]);
  const   style:any= useRef('CenterPane');
  const   [refresh, setRefresh] = useState({refresh:true});
  const   [joinedNum, setJoinedNum] = useState(-1);

  //console.log('CenterPanePlaylistMember...');
 // console.log('length=',joinedNames.current.length, joinedNames.current);
  // /props.playlistClass= 'member' 'public'
  function makeHtml(){
    htmlArry.current = [];
    //console.log(filenames);
    filenames.current.forEach(function(key1:any, index1:any, array1:any)
     {
        let path=key1.pathSuffix;
        let owner_id=key1.ownerID;
        let owner_name=key1.ownerName;
       // console.log('path=',path,' owner_id=',owner_id,' owner_name=',owner_name);
        let title= path.replace(/\.[^/.]+$/, "")
        title=decodeURI(title);
        htmlArry.current.push( <PlaylistCommunityItem title={title} key={keyCount}  path={path} ownerID={owner_id} ownerName={owner_name} setPlaylist={props.setPlaylist} user_id={props.user_id}/>);
        keyCount=keyCount+1;   
      });
    }

  useEffect(()=>{
    getJoindMemberlist('member_step1')
    .then(()=>{
       //makeHtml();
    });
  },[]);

  useEffect(()=>{
    getPlaylist('member_step2')
    .then(()=>{
       //makeHtml();
    });
  },[joinedNum]);

   async function getJoindMemberlist(playlist_class:any){//playlist_kind= member, public
    //let user_id=sessionStorage.getItem("user_id");
    let user_id= props.user_id;

    await axios({
      url: '/getCommunityPlaylist',// url 앞에 '/'를 안붙이면 /manage/getCommunityPlaylist를 호출한다.
      method: 'POST',
      data: {
        user_id: ''+user_id,
        mode: 'member_step1',
        page_num:''+joinedNum,
      },
      responseType: 'json'
    })
    .then( (ret_data:any)=>{ 
       //console.log(ret_data)
       //console.log(typeof ret_data)
       //console.log(ret_data.data)
       if (typeof ret_data.data === 'string') { ret_data.data=JSON.parse(ret_data.data);}
      // console.log(ret_data.data.FileStatuses);

       joinedNames.current=[];//clear
       //console.log("member_step1 #1")
       if (ret_data.data && ret_data.data.FileStatuses) {
          //console.log("member_step1 #2")
          var { data : {FileStatuses} } = ret_data;
          //console.log("member_step1 #3")
          FileStatuses.FileStatus.forEach((element: any) => {
            //console.log("member_step1 #4",element );
            joinedNames.current.push({ member_user_id: element.member_user_id});
          });
          setJoinedNum(0);
        }
    });
  }

  async function getPlaylist(user_id:any){//playlist_kind= member, public
    if(joinedNum<0) return;
    if(joinedNum<joinedNames.current.length)
    await axios({
      url: '/getCommunityPlaylist',// url 앞에 '/'를 안붙이면 /manage/getCommunityPlaylist를 호출한다.
      method: 'POST',
      data: {
        user_id: ''+joinedNames.current[joinedNum].member_user_id,
        mode: 'member_step2',
        page_num:''+joinedNum,
      },
      responseType: 'json'
  })
    .then( (ret_data:any)=>{ 
      filenames.current=[];//clear
      if (ret_data.data && ret_data.data.FileStatuses) {
        var { data : {FileStatuses} } = ret_data;
        FileStatuses.FileStatus.forEach((element: any) => {
            filenames.current.push({ pathSuffix: element.pathSuffix, ownerID: element.OwnerID,ownerName: element.OwnerName});
        });
        makeHtml();
        if(refresh.refresh) setRefresh({refresh:false});else  setRefresh({refresh:true});
      } else {
        // ret_data가 원하는 포맷이 아닐 경우에 대한 처리
      }
    });
  }

  ////////////
  function PlaylistCommunityItem(props:any)
  {
    const normal:React.CSSProperties ={border:'3px solid gray', position: 'relative'};
    const over:React.CSSProperties={border:'3px solid blue',position: 'relative'};
    const [color, setColor]= useState(normal);
    const selectStyle: React.CSSProperties = {
      backgroundColor: 'gray',
      position: 'absolute',
      left: '0px',
      top: '0px',
    };
   return(
       <button key={props.keyCount} className="CenterPlayList"  style={color} 
           onMouseEnter={()=>{setColor(over);
              // console.log('onMouseEnter PlaylistItem'); 
            }}
           onMouseLeave={()=>{setColor(normal);
              // console.log('onMouseLeave PlaylistItem');
            }}
           onClick={()=>{
             //console.log('props.path=',props.path, ' ,props.ownerID=',props.ownerID);
             lastClickedItemNum=-1;//clear selected button
             //if(style.current==='CenterPane')  props.setPlaylist(props.path);
             if(style.current==='CenterPane'){  
                // props.setPlaylist(props.path);
                //let user_id=sessionStorage.getItem("user_id");
                let user_id= props.user_id;
                var ownerID=props.ownerID;
                if(ownerID===user_id) ownerID="none";
                var strVar= `{"playlistFilename":"${props.path}","OwnerID":"${ownerID}"}`;//ownerID를 추가한다.
                props.setPlaylist(JSON.parse(strVar));
             }
             
            }
          }> {props.title}
          <div>
              <h1 style={selectStyle}> {props.ownerName} </h1>
          </div>
       </button>
    );
  }



  ////////////////////////////////////////////////
  // CenterPanePlaylistMember
  return(
     <div className={style.current}>
      <button className="CenterPaneCloudButton" onClick={()=>{ 
             //console.log('prev page');  
             let pg_num= joinedNum-1;
             if(pg_num<0) pg_num=0;
             setJoinedNum(pg_num);
             //console.log('prev page joinedNum=',joinedNum);  
        }}>Prev Page</button>
      <button className="CenterPaneCloudButton" onClick={()=>{ 
             let pg_num= joinedNum+1;
             if(joinedNames.current.length>=1 && pg_num<=joinedNames.current.length-1)   setJoinedNum(pg_num);
             //console.log('next page joinedNum=',joinedNum);  
        }}>Next Page</button>
        <div>
             {htmlArry.current}
         </div>
     </div>
  );
}
//////////////////////////////
//////////////////////////////
//////////////////////////////
//////////////////////////////
function CenterPanePlaylistCommunity(props:any){ //public
  const   filenames:any= useRef([]);
  const   htmlArry:any= useRef([]);
  const   style:any= useRef('CenterPane');
  const   [refresh, setRefresh] = useState({refresh:true});
  const   [page_num, setPageNum] = useState(1);

  // /props.playlistClass= 'member' 'public'
  function makeHtml(){
    htmlArry.current = [];
    //console.log(filenames);
    filenames.current.forEach(function(key1:any, index1:any, array1:any)
     {
        let path=key1.pathSuffix;
        let owner_id=key1.ownerID;
        let owner_name=key1.ownerName;
        //console.log('path=',path,' owner_id=',owner_id,' owner_name=',owner_name);
        let title= path.replace(/\.[^/.]+$/, "")
        title=decodeURI(title);
        htmlArry.current.push( <PlaylistCommunityItem title={title} key={keyCount}  path={path} ownerID={owner_id} ownerName={owner_name} setPlaylist={props.setPlaylist} user_id={props.user_id}/>);
        keyCount=keyCount+1;   
      });
    }

  useEffect(()=>{
    getCommunityPlaylistFiles(props.playlistClass)
    .then(()=>{
       //makeHtml();
    });
  },[]);

  useEffect(()=>{
    getCommunityPlaylistFiles(props.playlistClass)
    .then(()=>{
       //makeHtml();
    });
  },[page_num]);

   async function getCommunityPlaylistFiles(playlist_class:any){//get public playlist
    let user_id=sessionStorage.getItem("user_id");
    await axios({
      url: '/getCommunityPlaylist',// url 앞에 '/'를 안붙이면 /manage/getCommunityPlaylist를 호출한다.
      method: 'POST',
      data: {
        user_id: ''+user_id,
        mode: ''+playlist_class,
        page_num:''+page_num,
      },
      responseType: 'json'
  })
    .then( (ret_data:any)=>{ 
      filenames.current=[];//clear

      if (ret_data.data && ret_data.data.FileStatuses) {
        //var FileStatuses = ret_data.data.FileStatuses;
        var { data : {FileStatuses} } = ret_data;
        FileStatuses.FileStatus.forEach((element: any) => {
            filenames.current.push({ pathSuffix: element.pathSuffix, ownerID: element.OwnerID,ownerName: element.OwnerName});
        });
        makeHtml();
        if(refresh.refresh) setRefresh({refresh:false});else  setRefresh({refresh:true});
      } else {
        // ret_data가 원하는 포맷이 아닐 경우에 대한 처리
      }
    });
  }

  ////////////
  function PlaylistCommunityItem(props:any)
  {
    const normal:React.CSSProperties ={border:'3px solid gray', position: 'relative'};
    const over:React.CSSProperties={border:'3px solid blue',position: 'relative'};
    const [color, setColor]= useState(normal);
    const selectStyle: React.CSSProperties = {
      backgroundColor: 'gray',
      position: 'absolute',
      left: '0px',
      top: '0px',
    };
   return(
       <button key={props.keyCount} className="CenterPlayList"  style={color} 
           onMouseEnter={()=>{setColor(over);
              // console.log('onMouseEnter PlaylistItem'); 
            }}
           onMouseLeave={()=>{setColor(normal);
              // console.log('onMouseLeave PlaylistItem');
            }}
           onClick={()=>{
             //console.log('props.path=',props.path, ' ,props.ownerID=',props.ownerID);
             lastClickedItemNum=-1;//clear selected button
             //if(style.current==='CenterPane')  props.setPlaylist(props.path);
             if(style.current==='CenterPane'){  
                // props.setPlaylist(props.path);
                let user_id=sessionStorage.getItem("user_id");
                var ownerID=props.ownerID;
                if(ownerID===user_id) ownerID="none";
                var strVar= `{"playlistFilename":"${props.path}","OwnerID":"${ownerID}"}`;//ownerID를 추가한다.
                props.setPlaylist(JSON.parse(strVar));
             }
             
            }
          }> {props.title}
          <div style={selectStyle}>
              <h1> {props.ownerName} </h1>
              <h2> {props.ownerID} </h2>
          </div>
       </button>
    );
  }



  ////////////////////////////////////////////////
  // CenterPanePlaylistCommunity
  return(
     <div className={style.current}>
      <button className="CenterPaneCloudButton" onClick={()=>{ 
             //console.log('prev page');  
             let pg_num= page_num-1;
             if(pg_num<1) pg_num=1;
             setPageNum(pg_num);
        }}>Prev Page</button>
      <button className="CenterPaneCloudButton" onClick={()=>{ 
             //console.log('next page');  
             setPageNum(page_num+1);
        }}>Next Page</button>
        <div>
             {htmlArry.current}
         </div>
     </div>
  );
}
//////////////////////////////
function CenterPanePlaylist(props:any){
  const   filenames:any= useRef([]);
  const   htmlArry:any= useRef([]);
  const   style:any= useRef('CenterPane');
  const   [refresh, setRefresh] = useState({refresh:true});
  const   [mode, setMode] = useState({mode:"normal"});//normal, delete

  useEffect(()=>{
    //console.log('useEffect CenterPanePlaylist');  
    getListFiles('playlist').then(()=>{makeHtml();
      if(refresh.refresh) setRefresh({refresh:false});
      else  setRefresh({refresh:true});
    });
  },[]);

   useEffect(()=>{
    //console.log('useEffect CenterPanePlaylist');  
    if(mode.mode==='normal') style.current='CenterPane';
    else if(mode.mode==='delete') style.current='CenterPaneDeleteMode';
    getListFiles('/playlist').then(()=>{makeHtml()});
  },[mode]);


   async function getListFiles(url:any){
    //url-> 'playlist'
    await axios.get(url) //axios.get('playlist')
    .then( (ret_data:any)=>{ 
      filenames.current=[];//clear
        //console.log('getListFiles=',ret_data);
        var { data : {FileStatuses} } = ret_data;
        FileStatuses.FileStatus.forEach( (element:any) => {
          filenames.current.push(element);
        });
    });
  }
   async function deletePlaylist(filename:any){
    //filename=encodeURI(filename); //do not!!!
    //console.log('filename=',filename);
      await axios.post('/deletePlaylist/'+filename, {url:filename}) 
      .then( (ret_data:any)=>{ 
          //console.log('deletePlaylist ret_data=',ret_data);
          //if(refresh.refresh) setRefresh({refresh:false});
          //else  setRefresh({refresh:true});
          //style.current='CenterPane';
          //setMode({mode:"normal"});
          getListFiles('playlist').then(()=>{makeHtml();
            if(refresh.refresh) setRefresh({refresh:false});else  setRefresh({refresh:true});
          });
      
      });
    }


  async function uploadPlaylistMode(user_id:any,mode:any,filename:any,title:any,user_name:any){
    await axios({
          url: '/uploadPlaylistMode',//DB playlistTable에 저장한다. (playlist파일이 private, member, public 관련정보를 저장한다)
          method: 'POST',
          data: {
            user_id: ''+user_id,
            mode: ''+mode,
            filename: ''+filename,
            title: ''+title,
            user_name:''+user_name
          },
          responseType: 'json'
      })
      .then((response) => {
          //console.log(response.data);
         // setTimeout(()=>{props.onDraw();}, 500);
         
      });
}

async function getPlaylistMode(user_id:any,filename:any,propstype:any, setPropstype:any ){
  await axios({
        url: '/getPlaylistMode',//DB playlistTable에서 정보를 읽어온다.
        method: 'POST',
        data: {
          user_id: ''+user_id,
          filename: ''+filename,
        },
        responseType: 'json'
    })
    .then((response) => {
        //console.log(response.data);
       // setTimeout(()=>{props.onDraw();}, 500);
       //ToDo: ~~ propstype 변경이 있으면 호출 setPropstype
       if(response.data.mode!==propstype){
        setPropstype(response.data.mode);
       }
    });
}


  ////////////
  function PlaylistItem(props:any)
  {
    const normal:React.CSSProperties ={border:'3px solid gray', position: 'relative'};
    const over:React.CSSProperties={border:'3px solid blue',position: 'relative'};
    const [color, setColor]= useState(normal);
    const [propstype, setPropstype]= useState('private');//useState(props.type);
    const [refresh, setRefresh] = useState({refresh:true});

    //const selectStyle = { backgroundColor: 'gray',position:'absolute',left:'0px',top:'0px'};
    const selectStyle: React.CSSProperties = {
      backgroundColor: 'gray',
      position: 'absolute',
      left: '0px',
      top: '0px',
    };

    let user_id=sessionStorage.getItem("user_id");
    let filename= props.path;
    if(refresh.refresh) {
      setRefresh({refresh:false});
      getPlaylistMode(user_id,filename, propstype, setPropstype); //playlist파일이 private member public 여부를  DB에서 받아온다.
    }

   return(
    <button key={props.keyCount} className="CenterPlayList" style={color} 
           onMouseEnter={()=>{setColor(over);
              // console.log('onMouseEnter PlaylistItem'); 
            }}
           onMouseLeave={()=>{setColor(normal);
              // console.log('onMouseLeave PlaylistItem');
            }}
           onClick={()=>{
             //console.log('mode=',mode,' style.current=',style.current);
             lastClickedItemNum=-1;//clear selected button
             //if(style.current==='CenterPane') { props.setPlaylist(props.path);}
             if(style.current==='CenterPane') { 
                 // props.setPlaylist(props.path);
                 var strVar= `{"playlistFilename":"${props.path}","OwnerID":"none"}`;//ownerID를 추가한다.
                 props.setPlaylist(JSON.parse(strVar));
            }
            else {
             let confirmAction = window.confirm("Are you sure to delete this file?");
                if (confirmAction) {
                    //console.log('delete this file=',props.path);
                    deletePlaylist(props.path);
                } else {
                    //console.log("Action canceled");
               }
             }//else 
            }
          }> {props.title}
          <div>
          <select name="select_playlist_mode" id="playlist_type"  style={selectStyle} 
              disabled={props.user_id === "demo"}
              onChange={(e)=>{
                e.stopPropagation();
                setPropstype(e.target.value);
                //let user_id=sessionStorage.getItem("user_id");
                let user_id= props.user_id;
                let user_name=sessionStorage.getItem("user_name");
                let mode=e.target.value;
                let filename= props.path;
                let title= props.title;
                //console.log('onChange select user_id=',user_id,' mode=',e.target.value, 'playlisName=',props.path,' playlist_title=',props.title);

                //let filename ='_'+props.fileName+'.json';
                //updateJSON(props.fileName, e.target.value);
                 uploadPlaylistMode(user_id,mode,filename,title,user_name);//description, user_name
                 //ToDO: ~~
             }} value={propstype}>
             <option value="private">private</option>
             <option value="member">member</option>
             <option value="public">public</option>
         </select>
          </div>
           </button>
    );
  } //function PlaylistItem(props:any)

  function makeHtml(){
    htmlArry.current = [];
    filenames.current.forEach(function(key1:any, index1:any, array1:any)
      {
        let path=key1.pathSuffix;
        let title= path.replace(/\.[^/.]+$/, "")
        title=decodeURI(title);
        htmlArry.current.push( <PlaylistItem title={title} key={keyCount}  path={path} setPlaylist={props.setPlaylist} user_id={props.user_id} />);
        keyCount=keyCount+1;   
      });
    }

  return(
     <div className={style.current}>
      {mode.mode==='normal' && <button className="CenterPaneCloudButton" onClick={()=>{ 
             //console.log('dispatch createPlaylist event');  
             document.dispatchEvent(new Event("creatPlaylist", {
              cancelable: true
              //detail: { key1: "createPlaylist", key2:"none" }
         }));            
          ///..
        }}>Create </button>}

    {mode.mode==='normal' && <button className="CenterPaneCloudButton" onClick={()=>{ 
          setMode({mode:"delete"});
          style.current='CenterPaneDeleteMode';
          }}>Delete Mode</button>}

      {mode.mode==='delete' && <button className="CenterPaneCloudButton" onClick={()=>{ 
          style.current='CenterPane';
          setMode({mode:"normal"});}}>Back</button>}
      <br/>
      {htmlArry.current}
     </div>
  );
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function CloudItem(props:any)
{
  //var srcStr='/images/'+props.type;
  var info:any= useRef([props.fileName, props.type, props.title, props.info]);
  //var srcStr:any= useRef('/images/'+props.type);

  
  //if (props.style.current==="CenterPaneDeleteMode") { srcStr=srcStr+'X'; }//delete icon image
  const normal={border:'3px solid white'};
  const over={border:'3px solid blue'};
  const [color, setColor]= useState(normal);
  const [propstype, setPropstype]= useState(props.type);
  //const [viewMode, setViewMode]= useState("individual"); //individual  group
  const [viewMode, setViewMode] = useState(() => {
      if (props.type === "modelGroup") return "group";
       return "individual";
   });
  //const [scale, setScale]= useState("1"); 

  const [scale, setScale] = useState(() => {
      // return props.info.split(' ')[0];
      return props.info?.split(' ')[0] ?? '';
   });

  const [srcStr, setSrcStr]= useState('/images/'+props.type+'.png'); 


  function dragStartHandler(e:any){
        e.dataTransfer?.setData("info", info.current);
  }

  async function deleteCloudFile(filename:any){
   var url=filename;
   if(cloudCurrentFolder.lastIndexOf('/')===cloudCurrentFolder.length-1) url=cloudCurrentFolder+filename;
   else url=cloudCurrentFolder+'/'+filename;
    await axios.post('/deleteFile'+url, {url:url}); 
  }

  async function deleteCloudFolder(foldername:any){
    ////한글이름 채크
    var url=foldername;
    //var url=decodeURI(foldername);
    if(cloudCurrentFolder.lastIndexOf('/')===cloudCurrentFolder.length-1) url=cloudCurrentFolder+foldername;
    else url=cloudCurrentFolder+'/'+foldername;
    await axios.post('/deleteFolder'+url, {url:url}); 
   }
 //onMouseEnter onMouseLeave

 //3D모델파일 
   async function updateJSONModel(filename:any, scale:any, viewMode:any='individual'){
    var url=filename;
    if(cloudCurrentFolder.lastIndexOf('/')===cloudCurrentFolder.length-1) url=cloudCurrentFolder+filename;
    else url=cloudCurrentFolder+'/'+filename;

    let jsonStr='{"subtitle":"'+props.fileName+'","type":"model", "url":"'+props.fileName+'","info": "1.0 1.0 1.0"}';//dummy
    if (viewMode==="individual") jsonStr='{"subtitle":"'+props.fileName+'","type":"model","url":"'+props.fileName+'","info": "'+ scale+' ' + scale + ' '+scale+'"}';
    else if (viewMode==="group") jsonStr='{"subtitle":"'+props.fileName+'","type":"modelGroup","url":"'+props.fileName+'","info": "'+ scale+' ' + scale + ' '+scale+'"}';

    // console.log('url=',url,' jsonStr=',jsonStr);
    await axios({
          url: '/updateJSON',
          method: 'POST',
          data: {
            filename: ''+url,
            contents: jsonStr
          },
          responseType: 'json'
      })
      .then((response) => {
         // console.log(response.data);
        //  setTimeout(()=>{props.onDraw();}, 500);
      });
}

   //일반 ALL 360 파노라마+ 동영상+ 이미지 + 모델 + Scene
   async function updateJSON(filename:any,ftype:any){
      var url=filename;
    //   if (!/\.(jpg|png|jpeg|mpo|mp4|webm|glb|gltf|stl|)$/i.test(filename)) {
    //     return;
    // }

      if(cloudCurrentFolder.lastIndexOf('/')===cloudCurrentFolder.length-1) url=cloudCurrentFolder+filename;
      else url=cloudCurrentFolder+'/'+filename;
      let jsonStr='{"subtitle":"'+props.fileName+'","type":"'+ ftype +'", "url":"'+props.fileName+'","info": "1.0 1.0 1.0"}';
      //console.log('url=',url,' jsonStr=',jsonStr);

      await axios({
            url: '/updateJSON',
            method: 'POST',
            data: {
              filename: ''+url,
              contents: jsonStr
            },
            responseType: 'json'
        })
        .then((response) => {
           // console.log(response.data);
            setTimeout(()=>{props.onDraw();}, 500);
        });
  }
 
  var fileCatagory='unknown';
   try{
        fileCatagory='unknown';
        var extension = props.fileName.split('.').reverse()[0];
        //console.log('extension #1=',extension);
        //var scale= props.info.split(' ')[0];

        extension = extension.toLowerCase();
        //console.log('extension #2=',extension);
        if(  extension==='png' || extension==='jpg'|| extension==='jpeg' || extension==='mpo') fileCatagory='photos';
        else if(  extension==='mp4' || extension==='webm') fileCatagory='videos';
        else if(  extension==='glb' || extension==='gltf' || extension==='stl') fileCatagory='models';
    } catch(e) {
      //console.log('error ',e)
    }
    //console.log('props.fileName=',props.fileName,' fileCatagory=',fileCatagory);

  return(
    <div className="SubCenterCloudItem" draggable="true"  onDragStart={dragStartHandler} style={color} 
          onMouseEnter={()=>{
               setColor(over); 
           }
          }
          onMouseLeave={()=>{
           setColor(normal); 
       }
      }
      onClick={(e)=>{ 
           // console.log('onclick... props.fileName=',props.fileName);
            if (props.style.current==='CenterPaneDeleteMode'){
                    if(props.type==='folder'){  //delete folder!!!
                      ///
                      let confirmAction = window.confirm("Folder should be emty!! Are you sure to delete this folder?");
                      if (confirmAction) {
                          deleteCloudFolder(props.fileName).then(()=>{props.onDraw();});  
                      } else {
                          //console.log("Action canceled");
                     }
                    }
                    else {//delete file
                      let confirmAction = window.confirm("Are you sure to delete this file?");
                      if (confirmAction) {
                        deleteCloudFile(props.fileName).then(()=>{props.onDraw();});  
                      } else {
                          //console.log("Action canceled");
                     }
                }
            } else if(props.type==='folder') {
                 props.showFileViewer.current=false;
                 let temp_cloudCurrentFolder= cloudCurrentFolder;
                 if(cloudCurrentFolder.lastIndexOf('/')===cloudCurrentFolder.length-1) temp_cloudCurrentFolder=cloudCurrentFolder+props.title;
                 else temp_cloudCurrentFolder=cloudCurrentFolder+'/'+props.title;

                 //console.log('folder ',props.title,' clicked.... path=','cloudlist'+temp_cloudCurrentFolder);
                 props.getCloudFiles('cloudlist'+temp_cloudCurrentFolder).then(()=>{
                    cloudCurrentFolder= temp_cloudCurrentFolder;//디릭토리 리스트 성공해야 바꾸어 준다. 
                    props.onDraw();});   
            } else {
                // console.log('파일 버튼 클릭  e=',e);
                // console.log('파일 버튼 클릭  e=',e);
                // console.log('파일 버튼 클릭  e=',e);
                // console.log('파일 버튼 클릭  e=',e);
                // console.log('onclick props.fileName=',props.fileName,' clicked....');

                 //if (e.target instanceof HTMLDivElement|| e.target instanceof HTMLImageElement){    //  ||e.target instanceof HTMLHeadingElement) {
                  if (!(e.target instanceof HTMLSelectElement)){
                   // console.log('I Got you!!!');
                    var url=props.fileName;
                    if(cloudCurrentFolder.lastIndexOf('/')===cloudCurrentFolder.length-1) url=cloudCurrentFolder+props.fileName;
                    else url=cloudCurrentFolder+'/'+props.fileName;
                    //// 파일 버튼 클릭시에 호출 
                    //console.log('url=',url);//@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
                    //console.log('url=',url);
                    let jsonStr='{"type":"'+props.type+'","url":"'+ url+'","info":"'+props.info+'","access_token":"'+props.access_token+'"}';
                    //console.log('jsonStr=',jsonStr);
                    props.showFileInfo.current=jsonStr;
                    props.showFileViewer.current=true;
                    props.onDraw();
                }
                  ////
            }       
          }}
       > 
      {props.type!=='folder' && fileCatagory==='unknown' &&
       <div> 
        <select name="file_type2" id="file_type"  onChange={(e)=>{
                e.stopPropagation();
                setPropstype(e.target.value);
                console.log('onChange select=',e.target.value, 'filename=',props.fileName );
                //let filename ='_'+props.fileName+'.json';
                //console.log('filename=', props.fileName);
                // if(props.fileName.toLowerCase().endsWith('.zip')){
                //   //unzip 
                // }


                updateJSON(props.fileName, e.target.value);
             }} value={propstype}>
             <option value="photo">photo</option>
             <option value="photo360">photo360</option>
             <option value="photo3D">photo3D</option>
             <option value="photo3D180">photo3D180</option>
             <option value="photo3D360">photo3D360</option>
             <option value="video">video</option>
             <option value="video360">video360</option>
             <option value="video3D">video3D</option>
             <option value="video3D180">video3D180</option>
             <option value="video3D360">video3D360</option>
             <option value="model">model</option>
             <option value="unityscene">Scene</option>
             <option value="unknown">unknown</option>
         </select>
         </div>
         }

       {props.type!=='folder' && fileCatagory==='photos' &&
       <div> 
        <select name="file_type2" id="file_type"  onChange={(e)=>{
                e.stopPropagation();
                setPropstype(e.target.value);
                updateJSON(props.fileName, e.target.value);
             }} value={propstype}>
             <option value="photo">photo</option>
             <option value="photo360">photo360</option>
             <option value="photo3D">photo3D</option>
             <option value="photo3D180">photo3D180</option>
             <option value="photo3D360">photo3D360</option>
             <option value="unknown">unknown</option>
         </select>
         </div>
        }

       {props.type!=='folder' && fileCatagory==='videos' &&
       <div> 
        <select name="file_type2" id="file_type"  onChange={(e)=>{
                e.stopPropagation();
                setPropstype(e.target.value);
                updateJSON(props.fileName, e.target.value);
             }} value={propstype}>
             <option value="video">video</option>
             <option value="video360">video360</option>
             <option value="video3D">video3D</option>
             <option value="video3D180">video3D180</option>
             <option value="video3D360">video3D360</option>
             <option value="unknown">unknown</option>
         </select>
         </div>
        }

       {props.type!=='folder' && fileCatagory==='models'  &&
       <div> 
        <select name="file_type2" id="file_type"  onChange={(e)=>{
                e.stopPropagation();
                setScale(e.target.value);
                updateJSONModel(props.fileName, e.target.value, viewMode);
             }} value={scale}>
             <option value={scale} selected >scale {scale}</option>
             <option value="10000">scale 10000</option>
             <option value="1000">scale 1000</option>
             <option value="100">scale 100</option>
             <option value="10">scale 10</option>
             <option value="5">scale 5</option>
             <option value="2">scale 2</option>
             <option value="1">scale 1</option>
             <option value="0.5">scale 1/2</option>
             <option value="0.2">scale 1/5</option>
             <option value="0.1">scale 1/10</option>
             <option value="0.01">scale 1/100</option>
             <option value="0.001">scale 1/1000</option>
             <option value="0.0001">scale 1/10000</option>
             <option value="unknown">unknown</option>
             </select>
        <select name="file_type3" id="id_viewMode"  onChange={(e)=>{
                e.stopPropagation();
                updateJSONModel(props.fileName, scale, e.target.value);
                setViewMode(e.target.value);
                if(e.target.value==="individual") setSrcStr('/images/model.png');
                else setSrcStr('/images/modelGroup.png');
             }} value={viewMode}>
             <option value="individual">individual</option>
             <option value="group">group</option>
             </select>
         </div>
        }

       <img src={srcStr} alt="cloud item" width="50px" height="50px"></img>
       <h3>{props.title}</h3>
       <h4>({props.type})</h4>
    </div>
  );
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//const handleAuthChange = () => {
//  //console.log('promise=',auth.isSignedIn.get()) ;
//  console.log('google Drive handleAuthChange...') ;
//};
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function CenterPaneCloudlist(props:any){
  const htmlArry:any= useRef([]);
  const uploadfiles:any= useRef([]);
  const cloudfiles:any = useRef([]);
  const style:any= useRef('CenterPane');
  const [mode, setDisplayMode] = useState({mode:"normal"}); //normal delete upload  now_uploading
  const [refresh, setRefresh] = useState({refresh:true});
  const showFileViewer:any = useRef(false);
  const showFileInfo:any = useRef('{"type":"unknown","url":"none"}');
  
/* 
LISTSTATUS=  {
    "FileStatuses": 
      {
        "CurrentFolder": "/",  <==  /mnt/72849f17-72de-44bc-893b-1206184c6e43/cloud
     		"FolderStatus": ["folder01", "folder02", "folder032"],   
        "FileStatus": [
            {"pathSuffix":"%EC%9D%B4%EC%A7%80%ED%9B%88.JPG"},
            {"pathSuffix":"DSCF9151.MPO"},{"pathSuffix":"DSCF9152.MPO"}
         ]
      }
  }
*/

 useEffect(()=>{
    //console.log('useEffect  #1');  
  },[]);

   useEffect(()=>{
      //console.log('useEffect  #2 mode=',mode);  
      if(mode.mode==='delete' || mode.mode==='normal'){
          getCloudFiles('cloudlist'+cloudCurrentFolder).then(()=>{
              makeHtml();
              if(refresh.refresh) setRefresh({refresh:false});
              else  setRefresh({refresh:true});
       });}
   },[mode]); //delete upload normal
     
   async function createCloudFolder(url:any){
      //console.log('createCloudFolderdFiles....['+url+']');
      await axios.get(url) 
         .then( (ret_data:any)=>{ 
              setDisplayMode({mode:"normal"});
        });
   }

   async function getCloudFiles(url:any){
    cloudfiles.current=[];//clear
    /*
        {
            "subtitle":"tree1.glb",
            "viewMode":"individual", <-- 추가 
            "type":"model",
            "url":"/resources/tree1.glb",
            "info":"1.0 1.0 1.0"
         }
         title-> subtitle   option->info   filename->url 
    */

    await axios.get(url) 
    .then( (ret_data:any)=>{ 
        var { data : {FileStatuses} } = ret_data;
        FileStatuses.FolderStatus.forEach( (element:any) => {
          //var jsonStr ='{"title":"'+element+'","filename":"'+element+'","type":"folder","option":"none"}';
          var jsonStr ='{"subtitle":"'+element+'","type":"folder","url":"'+element+'","info":"none"}';
          cloudfiles.current.push( JSON.parse(jsonStr) );
        });
        FileStatuses.FileStatus.forEach( (element:any) => {
           //if (element.type === "model" && !("viewMode" in element)) {
           if (!("viewMode" in element)) {
              element.viewMode = "individual"; //<-- 신규추가로 기존 데이터에 없으면 기본설정해 준다. 
          }
          cloudfiles.current.push( element);
        });
    });
  }

  function uploadToCloud(e:any) {
    if(uploadfiles.current.length<1) {setDisplayMode({mode:"normal"}); return;}
    setDisplayMode({mode:"now_uploading"});//show uploading icon
    setTimeout(()=>{uploadToCloud2(e);}, 1500);
  }
  
  function delayedToNormalMode(){
    setTimeout(()=>{
      // file post 시작만 해놓고 루프가 끝난다. 큰 사이즈의 동영상은 업로드하여도  한참동안 파일이 보이지 않를 수 있다.
      setDisplayMode({mode:"normal"});
    }, 1000);
  }

  function uploadToCloud2(e:any) {
      //console.log('uploadToCloud()...',uploadfiles.current);
      htmlArry.current=[];//clear
      cloudfiles.current=[];//clear

      e.stopPropagation();
      e.preventDefault();
      var url = 'uploadFile/';
      const config = {
          headers: {
              'content-type': 'multipart/form-data',
            },
        };

      var cloudURL='uploadFile'+cloudCurrentFolder;//backup current in case of changing by user!!
      // 업로드 전에 파일용량과  업로드 가능한 클라우드 용량을 확인할 필요가 있다. 
      var totalBytes=0;
      uploadfiles.current.forEach(function(filelist:any, index:  any, array:any){
        for(let i=0;i<filelist.length;i++ ){
          let fileSizeInBytes = filelist[i].size;
          totalBytes = totalBytes + fileSizeInBytes;
        }       
      });
      var fileSizeInMegabytes = totalBytes / (1024*1024);
     
      let user_id=sessionStorage.getItem("user_id");
      var quota= 0;
      var quotaUsage= 0;

      //console.log('user_id=',user_id);
      axios({
        url: '/getCheckDiskQuta',
        method: 'POST',
        data: {
           user_id: ''+user_id	
          },
          responseType: 'json'
        })
      .then((response) => {
        //console.log(response.data);
        quota= Number(response.data.quota);
        quotaUsage= Number(response.data.quotaUsage);
        //console.log('quota=',quota,' quotaUsage=',quotaUsage);

        if(isNaN(quota) || isNaN(quotaUsage)) { 
          // console.log('quota/quotaUsage is not available');
           alert('quota/quotaUsage is not available!');
           delayedToNormalMode();
           return;
        }
        if(quota!==0 && (quota<quotaUsage)){ //quota==0이면 제한이 없다. 
          alert('Disk space is full!!');
          delayedToNormalMode();
          return;
        }
        if(quota!==0 && (fileSizeInMegabytes+quotaUsage>quota)){
          alert('Disk space is not sufficient!');
          delayedToNormalMode();
          return;
        }
         ///////////////////////////////
         uploadfiles.current.forEach(function(filelist:any, index:  any, array:any){
          //console.log('filelist=',filelist); 
          for(let i=0;i<filelist.length;i++ ){
            if(cloudCurrentFolder.lastIndexOf('/')===cloudCurrentFolder.length-1) url= cloudURL+filelist[i].name;
            else url= cloudURL +'/'+filelist[i].name;
            //console.log('axios post  url=',url);
            //console.log('   filelist[i]=',filelist[i]);

            ///var urlData = 'http://localhost/uploadFile/'+ filelist[i].name;//data channel
            var formData = new FormData();
            formData.append('file', filelist[i]);
            formData.append('fileName', filelist[i].name);
            axios.post(url, formData, config).
              then((response) => {
                 // console.log('response.data=',response.data);
                  //console.log('sending ..'+i);
              });
          }//for
          delayedToNormalMode();
         });
         ///////////////////////////////////
      });//then
 }

   function handleChange(event:any) {
    //console.log('handleChange=',event.target.files[0]); 
    uploadfiles.current.push(event.target.files);
  }

  function onDraw(){
    //console.log('onDraw');
    getCloudFiles('cloudlist'+cloudCurrentFolder).then(()=>{
      makeHtml();
      if(refresh.refresh) setRefresh({refresh:false});
      else  setRefresh({refresh:true});
    });
  }

  function makeHtml(){
      htmlArry.current= [];
      //console.log('CenterPaneCloudlist... #1  length=',cloudfiles.current.length,'  mode=',mode);
      cloudfiles.current.forEach(function(key1:any, index1:any, array1:any)
      { 
        //console.log('key1=',key1);
        var subtitle=decodeURI(key1.subtitle);
        htmlArry.current.push( <CloudItem key={keyCount} title={subtitle} type={key1.type} info={key1.info} className="CenterCloudItem" fileName={key1.url} onDraw={onDraw} style={style}
           showFileViewer={showFileViewer} showFileInfo={showFileInfo}  getCloudFiles={getCloudFiles} access_token={props.access_token} />);
        keyCount=keyCount+1;   
      });
      //console.log('CenterPaneCloudlist... #2');
      //if(mode.mode ==='delete') {style.current="CenterPaneDeleteMode";}
      //else {style.current="CenterPane";}
      //console.log('mode.mode=',mode.mode,'  style.current=',style.current);
  }

  function FileViewerControl(props:any){
    //console.log('props.showFileInfo.current=',props.showFileInfo.current);
    let json= JSON.parse(props.showFileInfo.current); //{"type":"unknown","url":"none"}
    let srcStr= '/vr/fileviewer.html?param1='+json.type+'&param2='+json.url+'&param3='+json.info+'&access_token='+json.access_token;
    //console.log('srcStr=',srcStr);
    return (
      <div className="floating-box"  
          onClick={()=>{
              //props.showFileViewer.current=false;//hide
              //console.log('FileViewerControl click');
              //props.onDraw();
            }} 
          onDragStart={()=>{ 
                //console.log('onDragStart');
             }}
          onDrop={()=>{ 
               //console.log('onDrop'); 
             }}       
       >
        <img src="/images/x.png" alt="del"  onClick={()=>{
              props.showFileViewer.current=false;//hide
              //console.log('FileViewerControl click');
              props.onDraw();
        }} />
        <iframe title='File Viewer' className="fileviewer-box" src={srcStr}></iframe>
    </div>
 );
  }
/*
         <div style="left: 0px; border: 0px none; height: 370px; position: fixed; width: 270px; overflow: hidden; bottom: -67px;">
           <div style="overflow: hidden;">
             </div>
               <iframe src="http://weather.gc.ca/wxlink/wxlink.html?cityCode=on-162&amp;lang=e" scrolling="no" style="height: 300px; border: 0px none; width: 165px; margin-bottom: 0px; margin-left: 24px;">
            </iframe>
           </div>
        </div>
*/
 let deleteButtonText='Delete';
 if(mode.mode ==='delete') deleteButtonText='Back';
  return(
     <div className={style.current}>
         <button className="CenterPaneCloudButton" onClick={()=>{
              //console.log('Create Folder Button');
              if(mode.mode!=='upload') setDisplayMode( {"mode":"createfolder"});
              else setDisplayMode({"mode":"normal"});

              let folder_name = prompt("Please enter folder name", "folder01");
              if (folder_name===null) return;//folder_name="folder01";
              //folder_name=encodeURI(folder_name);
              //console.log('create folder=',folder_name); 
              var url= 'cloudcreate'+cloudCurrentFolder;
              if(url.lastIndexOf('/')===url.length-1) url= url+ folder_name;
              else url= url+ '/'+ folder_name;;
              createCloudFolder(url);
              if(props.showFileViewer) props.showFileViewer.current=false;
              //props.onDraw();
            }}
          >Create Folder</button>

         <button className="CenterPaneCloudButton" onClick={()=>{
              if(mode.mode !=='delete') {style.current="CenterPaneDeleteMode";setDisplayMode({"mode":"delete"});}
              else {style.current="CenterPane"; setDisplayMode({"mode":"normal"});}
              if(props.showFileViewer) props.showFileViewer.current=false;
              //props.onDraw();
              //console.log('cloud file delete mode...');
            }}>{deleteButtonText}</button>

         <button className="CenterPaneCloudButton" onClick={()=>{
              style.current="CenterPane";
              if(mode.mode!=='upload') setDisplayMode( {"mode":"upload"});
              else setDisplayMode({"mode":"normal"});
              uploadfiles.current=[];//clear!!
              if(props.showFileViewer) props.showFileViewer.current=false;
              //props.onDraw();
              // console.log('cloud file upload mode...');
            }}
          >Upload</button>

         <div>
               <button onClick={()=>{
                    //console.log('Up Folder Button');
                    var tempFolder=cloudCurrentFolder;//copy
                    //console.log('Up Folder Button>>>  tempFolder=',tempFolder);
                    if(tempFolder.length>=2){ 
                        if(cloudCurrentFolder.lastIndexOf('/')===cloudCurrentFolder.length-1) tempFolder= cloudCurrentFolder.slice(0,cloudCurrentFolder.length-2);//마지막 '/'를 잘라낸다.
                        //console.log('tempFolder=',tempFolder);
                        if(tempFolder.lastIndexOf('/')>0)  cloudCurrentFolder=tempFolder.slice(0, tempFolder.lastIndexOf('/'));
                        else cloudCurrentFolder='/';
                    } else {cloudCurrentFolder='/';}

                    //console.log('cloudCurrentFolder=',cloudCurrentFolder);
                    showFileViewer.current=false;
                    getCloudFiles('cloudlist'+cloudCurrentFolder).then(()=>{
                         onDraw();  //makeHtml();
                    });
                  }}>Up Folder</button>
                  <strong>&nbsp;Current Folder : {cloudCurrentFolder}</strong>
          </div>
         { mode.mode==='upload'  &&  
              <div className="CenterPaneCloudUpload">
                  <form onSubmit={uploadToCloud}>  
                      <input type="file"  data-multiple-caption="{count} files" multiple  onChange={handleChange} />
                      <input type="submit" />
                  </form>
            </div>}
          { mode.mode==='now_uploading'  &&  <LoadingSpinner /> }
          { mode.mode!=='now_uploading' &&
            <div className="CenterPaneCloudItemContainer"> 
              {htmlArry.current }
            </div>}
            {/*showFileViewer.current &&  <FileViewerControl  showFileViewer={showFileViewer} showFileInfo={showFileInfo}  access_token={props.access_token} onDraw={onDraw}  /> */}
     </div>
  );
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//            

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function WebCamControl(props:any){
  const [refresh, setRefresh] = useState({refresh:false}); 
 return(
     <div>
         {<input type="image" className="ThreeButtons" alt="webcam_end" src="/images/webcam_end.png" 
           onClick={()=>{
            isWebCameraOn=false;
            //console.log('make false   isWebCameraOn=',isWebCameraOn);
            if(refresh.refresh) setRefresh({refresh:false});
            else  setRefresh({refresh:true});
            aTagClick(props.setMessage, 'webcam','webcam off','dummy', props.access_token);

            document.dispatchEvent(new CustomEvent("webcam", {
              cancelable: true,
              detail: { command: "webcam", para1:"video broadcast off" }
            }));

          }}/>}

         {isVideoBrodcast===false && <input type="image" className="ThreeButtons" alt="webcam_video_off" src="/images/webcam_video_off.png"
            onClick={()=>{
               isVideoBrodcast=!isVideoBrodcast;
               //console.log('isVideoBrodcast=',isVideoBrodcast);
               if(refresh.refresh) setRefresh({refresh:false});
               else  setRefresh({refresh:true});

               document.dispatchEvent(new CustomEvent("webcam", {
                cancelable: true,
                detail: { command: "webcam", para1:"video broadcast on" }
              }));
              }}/>}

         {isVideoBrodcast && <input type="image" className="ThreeButtons" alt="webcam_video_on" src="/images/webcam_video_on.png"
             onClick={()=>{
               isVideoBrodcast=!isVideoBrodcast;
               if(refresh.refresh) setRefresh({refresh:false});
               else  setRefresh({refresh:true});
                  document.dispatchEvent(new CustomEvent("webcam", {
                    cancelable: true,
                    detail: { command: "webcam", para1:"video broadcast off" }
                  }));
                      }}/>}
         
         {isAudioBrodcast===false && <input type="image" className="ThreeButtons" alt="webcam_audio_off" src="/images/webcam_audio_off.png"
             onClick={()=>{
                isAudioBrodcast=!isAudioBrodcast;
                //console.log('isAudioBrodcast=',isAudioBrodcast);
                if(refresh.refresh) setRefresh({refresh:false});
                else  setRefresh({refresh:true});
                      document.dispatchEvent(new CustomEvent("webcam", {
                        cancelable: true,
                        detail: { command: "webcam", para1:"audio broadcast on" }
                      }));
                        }}/>}
         {isAudioBrodcast && <input type="image" className="ThreeButtons" alt="webcam_audio_on" src="/images/webcam_audio_on.png" 
             onClick={()=>{
                isAudioBrodcast=!isAudioBrodcast;
                //console.log('isAudioBrodcast=',isAudioBrodcast);
                if(refresh.refresh) setRefresh({refresh:false});
                else  setRefresh({refresh:true});

                document.dispatchEvent(new CustomEvent("webcam", {
                      cancelable: true,
                      detail: { command: "webcam", para1:"audio broadcast off" }
                }));
                    }}/>}
     </div>   
 );
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function RightPane(props:any){

      const value =useContext(UserContext)
      const myContext= useRef(value);
      const roomCreated= useRef(false);
      
      var htmlArray:any=[];
      var keyCount=1;
      const [refresh, setRefresh] = useState({refresh:false});
    // const [connectedUser, setData] = useState(myContext.current.connectedUser);

      const myBefore= useRef(myContext.current.connectedUser.length);

      document.addEventListener("roomCreated", function(event) { 
        event.stopImmediatePropagation();
        event.stopPropagation();
        event.preventDefault();
        roomCreated.current= true;
        //console.log('Event=',event); 
        onDrawRightPane();
      });


      useEffect(()=>{
        //이 부분이 동작되지 않는다.??
        htmlArray=[];//clear!!  
        myContext.current.connectedUser.forEach( (element:any) => {
          //console.log('connectedUser #2=',element); 
          let key= keyCount+ new Date().getTime();
          htmlArray.push(<h1 key={key}>&nbsp;&nbsp;{keyCount+'. '+element.user_name}</h1>);
          // eslint-disable-next-line react-hooks/exhaustive-deps
          keyCount=keyCount+1;
          });
          ///onDrawRightPane();
    //      setData(myContext.current.connectedUser);
        },[myContext.current.connectedUser, myContext.current.connectedUser.length]); 


      const [checkedUsers, setCheckedUsers] = useState(new Set());
      const handleCheckboxChange = (element:ConnectedUser) => {
        setCheckedUsers(prev => {
            const newSet = new Set(prev);
            if (newSet.has(element.socket_id)) {
              newSet.delete(element.socket_id);
              console.log("element.socket_id="+element.socket_id+" is cleared  with "+props.access_token);
              aTagClick(props.setMessage,"changeRole","student",element.socket_id, props.access_token)
            } else {
              newSet.add(element.socket_id);
              console.log("element.socket_id="+element.socket_id+" is checked  with "+props.access_token );
              aTagClick(props.setMessage,"changeRole","teacher",element.socket_id, props.access_token)
            }
            return newSet;
        });
      };

      type ConnectedUser = {
          room: string;
          user_name: string;
          socket_id: string;
          role: string;
      };

      function makeHtml() {
          htmlArray = []; // clear
          myContext.current.connectedUser.forEach((element:ConnectedUser) => {
            let key = keyCount + new Date().getTime();

            htmlArray.push(
              <div key={key} style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="checkbox"
                  checked={checkedUsers.has(element.socket_id)}
                  onChange={() => handleCheckboxChange(element)}
                  style={{ marginRight: "10px", cursor: "pointer" }}
                />
                <h1 style={{ margin: 0 }}>
                  {keyCount + ". " + element.user_name}
                </h1>
              </div>
            );
            keyCount++;
          });
          return htmlArray;
        }

      makeHtml();
      //setTimeout(mywait, 5000);

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      function onDrawRightPane()
      {
        //console.log(' onDrawRightPane()....');
        if(refresh.refresh) setRefresh({refresh:false});
        else  setRefresh({refresh:true});
      }
      
      /// 접속 학생 리스트를 보여주기 위해 refresh 한다.
      // function mywait(){
      //   console.log("Test #3")  
      //   makeHtml();
      //   onDrawRightPane();

      //   // if(myContext.current.connectedUser.length !== myBefore.current){
      //   //   console.log('refresh............',myContext.current.connectedUser);
      //   //   makeHtml();
      //   //   onDrawRightPane();
      //   //   myBefore.current=myContext.current.connectedUser.length;
      //   // }
      //   ///console.log('myBefore.current=',myBefore.current, '  length=',myContext.current.connectedUser.length);
      //   console.log("Test #4")  
      //   setTimeout(mywait, 5000);
      // }

  return(
    <div className="RightPane">
        <button className="RightPaneButton" onClick={()=>{
            lastClickMode='PlayList';
            props.setLeftDisplay("playlist");
            props.setCenterDisplay("playlist")}}>
              <h3 className="RightPaneButtonText">Private Lists</h3>
        </button>

       {props.user_id!== "demo" && <button className="RightPaneButton" onClick={()=>{
            lastClickMode='PlayList';
            props.setCenterDisplay("playlist_member")
            props.setLeftDisplay("playlist_member");
          }}><h3 className="RightPaneButtonText">Member Lists</h3>
        </button>}

        <button className="RightPaneButton" onClick={()=>{
            lastClickMode='PlayList';
            //console.log('Public Lists...');
            props.setCenterDisplay("playlist_public");//<-- setCenterDisplay("playlist_public");
            props.setLeftDisplay("playlist_public");
           }}><h3 className="RightPaneButtonText">Public Lists</h3>
        </button>

         {props.user_id!== "demo" && <button className="RightPaneButton" onClick={()=>{
            lastClickMode='PlayList';
           // console.log('Manage Members...');
            props.setCenterDisplay("manage_member");//<-- setCenterDisplay("playlist_public");
            props.setLeftDisplay("manage_member");
           }}><h3 className="RightPaneButtonText">Manage Members</h3>
        </button>}


         {props.user_id!== "demo" && <button className="RightPaneButton"  onClick={()=>{
            //lastClickMode.current='MyCloud';
            lastClickMode='MyCloud';
            cloudCurrentFolder='/';//root 폴더로 초기화한다.
            props.setCenterDisplay("cloudlist")}}>
            <h3 className="RightPaneButtonText">Media Library</h3>
         </button>}



         { <button className="RightPaneButton"  onClick={()=>{
                if(lastClickMode ==='VRMode' || lastClickMode ==='none' ){
                    props.setCenterDisplay("vrworld"); //go VRHome!!!
                    if(lastClickMode ==='none'){
                          aTagClick(props.setMessage, 'photo360','/images/home.jpg','1.0 1.0 1.0', props.access_token);
                    }
                } else{
                    props.setCenterDisplay("vrworld");
                }
                  lastClickMode='VRMode';
                }}><h3 className="RightPaneButtonText">Broadcast</h3>
           </button>
         }


        {props.user_id!== "demo" &&  <button className="RightPaneButton" onClick={()=>{
                    lastClickMode='VRMode';
                    //console.log(g_leftwingPlayCard);
                    //Preload(cache) 기능을 삭제 2024.10.06 ->비번변경으로 활용
                    //if(g_leftwingPlayCard!==undefined){
                    //    aTagClick(props.setMessage, 'preload',g_leftwingPlayCard,'1.0 1.0 1.0',  props.access_token);//(1)
                    //}
                    props.setCenterDisplay("changePwd");

                }}><h3 className="RightPaneButtonText">Change Password</h3>
              </button>
         }

         {props.user_id!== "demo" && (isWebCameraOn==false) && (roomCreated.current==true) &&  
            <button className="RightPaneButton"  onClick={()=>{ 
              //Starting Webcam....
                isWebCameraOn=true;
                //console.log('make true   isWebCameraOn=',isWebCameraOn);
                onDrawRightPane();
                aTagClick(props.setMessage, 'webcam','webcam on','dummy', props.access_token);
                }}>Webcam On</button>
        }


        {props.user_id!== "demo" &&  isWebCameraOn && <video id="localWebCamVideo" width="100%"  autoPlay={true} loop={false}  muted></video>}            

        { props.user_id!== "demo" && 
          isWebCameraOn && <WebCamControl  setMessage={props.setMessage} webCamMessage={props.webCamMessage} access_token={props.access_token} ></WebCamControl>
        }
        {   htmlArray  }
    </div>
 );
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function Footer(){
  //console.log('Footer()...');

  return(
    <div className="Footer">
        <footer>
          <h1> Good </h1>
        </footer>
     </div>
  );
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function reducerFunc(state:any, action:any) {
  //console.log('>>>>>>',state,action);
  switch (action.type) {
    case 'playlist':  
     return {...state, playlist:action.payload};
    case 'isLoading':
      return {...state, isLoading:action.payload};
    case 'DECREASE':
      return {...state, count: state.count-1};
    default:
      return state;
  }
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function Header(props:any){
   return(
    <div  className="App-header">
         <br/><h1>&nbsp;&nbsp;VRWorld</h1>

         {/*
         <div className="App-header-changepassword">
             <button className="ChangepwdBtton" onClick={()=>{
                console.log('changepassword clicked!!');
                props.setCenterDisplay("changePassword");

                //aTagClick(props.setMessage, props.jsonData.type, props.jsonData.url,props.jsonData.info, access_token);
                //makeRefresh();
                //  props.renewRefresh();
            }}>Change Password</button>
          </div>  
          */}
     </div>
   );
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function Spinner(){
  useEffect(() => {
    //  console.log('Spinner Module...');
  }, []);
  return(
    <div>Loading...</div>
  );
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function App() {

  const [isLogin, setIsLogin] = useState(false);
  const class_id= useRef('');
  const user_id= useRef('');
  const user_name= useRef('');
  const [refresh, setRefresh] = useState({refresh:false});


   var myContext = useContext(UserContext);
   const [browserFlag, setBrowserFlag] = useState(false);//display only on the Browser!!
   const [playlist, setPlaylist] = useState(myContext.playlist);
   const [centerDisplay, setCenterDisplay] = useState(myContext.centerDisplay);// playlist cloudlist vrworld
   const [leftDisplay, setLeftDisplay]= useState(myContext.leftDisplay);// playlist playlist_public playlist_member
   const [message, setMessage] = useState(myContext.message);
   const [connectedUser, setConnectedUser]= useState(myContext.connectedUser);
   const webCamMessage= useRef(myContext.webCamMessage);
   const [generalMessage, setGeneralMessage] = useState(myContext.generalMessage);


   const onDraw= function()
   { //force redraw all
      console.log('onDraw() is called....');
      if(refresh.refresh) setRefresh({refresh:false});
      else  setRefresh({refresh:true});
   }

   //console.log("centerDisplay=",centerDisplay);
   useEffect(() => {
     setBrowserFlag(true);
     document.title = 'VR Edu Manage';
     //if(gapi===null) loading_gapi();//for Server Side Rendering 
     //console.log('setBrowserFlag browserFlag=',browserFlag);
    }, []);
 
    
//기존 handleSubmit 함수를 변경한다.
const trylogin = async (in_userid:any, in_passwd:any)=>{
  //console.log('trylogin...');
 
  const data_promise=  await axios.post(
    '/login',  //<==  서버의 app.post('/login'.. 부분을 호출한다.
    {
      userid: in_userid,
      passwd: in_passwd
    }
  );
  return data_promise;
}



const tryChangePassword = async (userid:any, oldpasswd:any, newpasswd:any)=>{
  console.log('tryChangePassword...'+userid+" "+oldpasswd+" "+newpasswd);
  const data_promise=  await axios.post(
    '/changepwd',  //<==  서버의 app.post('/login'.. 부분을 호출한다.
    {
      userid: userid,
      oldpasswd: oldpasswd,
      newpasswd: newpasswd         
    }
  );
  return data_promise;
}


const handleSubmit = (event:any) => {
  //Prevent page reload
  event.preventDefault();
  var { uname, pass } = document.forms[0];
  //console.log('handleSubmit called...','event=',event);
  //console.log('handleSubmit called...','document.forms',document.forms);
  //console.log('handleSubmit called...','uname=',uname.value,' pass=',pass.value);

  const return_promise= trylogin(uname.value, pass.value);

  return_promise.then(
    function(value:any) { // code if successful
     // console.log('value.data.user_id=',value.data.user_id);
     // console.log('value.data.name=',value.data.name);
    //  console.log('value.data.access_token=',value.data.access_token);
    // console.log('value.data.status=',value.data.status);

      if(value.data.status==="success"){
             class_id.current= value.data.user_id;//교사의 id를 class_id로 사용 (추후 변경)
             user_name.current=value.data.name;//backup
             user_id.current=value.data.user_id;//backup
             let user_type= value.data.user_type;
             //console.log(user_type);
             if(user_type!=='publisher') {
                 alert("Login failed with consumer");
                return;
             }

             sessionStorage.setItem("user_id", user_id.current);//write 
             sessionStorage.setItem("user_name", user_name.current);//write 
             //sessionStorage.setItem("class_id", class_id.current);//write 

             //sessionStorage.setItem("access_token", value.data.access_token);//write 
             //console.log('saved access_token=',sessionStorage.getItem("access_token"));//read

             setMessage({para1:'', para2:'', para3:'',access_token:value.data.access_token});
             access_token= value.data.access_token; //global variable!!
             //axios_config = { //renew axios_config
             //  headers: { Authorization: `Bearer ${access_token}` }
             //};

             axios.defaults.withCredentials = true;
             axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
             setIsLogin(true);
      } else {
        alert("Login failed with status "+value.data.status);
      }
    },
    function(error:any) { // code if some error
         // console.log(error);
      }
  );
};

function LoginDialog(){
      return(
       <div className="login-form">
         <div className="title">Login</div>
         <div className="form">
           <form onSubmit={handleSubmit}>
             <div className="input-container">
               <label>UserName(ClassID) </label>
               <input type="text" name="uname" required />
             </div>
             <div className="input-container">
               <label>Password </label>
               <input type="password" name="pass" required />
             </div>
             <div className="button-container">
               <input type="submit" name="login"/>
               <label><br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <a  style={{bottom:"0px"  }} href="/member">Sign In</a></label>

                <label><br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <a  style={{bottom:"0px"  }} href="/vr/manual_english.html">Manual</a></label>
             </div>
           </form>
         </div>
       </div>
      );
    }

     ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    function ChangePasswordDialog(props:any){
        //componet
        function changePasswordSubmit(event:any)  {
              //Prevent page reload
              event.preventDefault();
              //console.log('handleSubmit called...','event=',event);
              var { uname, oldpass, newpass1,newpass2} = document.forms[0];
              //console.log('handleSubmit called...','event=',event);
             // console.log('handleSubmit called...','document.forms',document.forms);
             // console.log('handleSubmit called...','uname=',uname.value,' oldpass=',oldpass.value,' newpass1=',newpass1.value);
              if(newpass1.value.length<4){
                  alert('Password length should be longer then 4.');
                  return;
              } 
              if(newpass1.value!==newpass2.value){
                alert('New Password and Conform Pasword is different.');
                return;
              }
  
              const return_promise= tryChangePassword(uname.value, oldpass.value, newpass1.value );
              return_promise.then(
                function(value:any) { // code if successful
                  if(value.data.status==="success"){
                      alert('Password is changed sucessfully');
                      props.setCenterDisplay("playlist");
                  } else {
                    alert("Changing password is failed");
                    props.setCenterDisplay("playlist");
                  }
                },
                function(error:any) { // code if some error
                    //console.log(error);
                  }
              );
            }
  
       return(
             <div className="login-form">
               <div className="title">Change Password</div>
               <div className="form">
                 <form onSubmit={changePasswordSubmit}>
                   <div className="input-container">
                     <label>UserName(ClassID) </label>
                     <input type="text" name="uname" value={class_id.current} readOnly={true} />
                   </div>
                   <div className="input-container">
                     <label>Old Password </label>
                     <input type="password" name="oldpass" required />
                   </div>
                   <div className="input-container">
                     <label>New Password </label>
                     <input type="password" name="newpass1" required />
                   </div>
      
                   <div className="input-container">
                     <label>Confirm Password</label>
                     <input type="password" name="newpass2" required />
                   </div>
                   <div className="button-container">
                     <input type="submit" name="Submit"/>
                   </div>
                 </form>
               </div>
             </div>
            );
          }
          ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//by pass login
//access_token='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiaGVlYm9rQGdtYWlsLmNvbSIsIm5hbWUiOiJEci4gSGVlIEJvayBMZWUiLCJmb2xkZXIiOiI3Mjg0OWYxNy03MmRlLTQ0YmMtODkzYi0xMjA2MTg0YzZlNDMiLCJpYXQiOjE2NjYxNDgwODQsImV4cCI6MTY2NjIzNDQ4NH0.-HjiMndigyneNd4XJBpK89LuTcgCCj78hO-1OsiWCGU';
//class_id.current= 'heebok@gmail.com';
//user_name.current='heebok';
//user_id.current='heebok@gmail.com';
//console.log('user_id.current=',user_id.current);
 return (
    <div className="App">
          <UserContext.Provider value={userData}>
           {isLogin===false && <LoginDialog />}
           {isLogin===true && 
             <div><Header setCenterDisplay={setCenterDisplay} ></Header>
                 <div className="container">
                    {leftDisplay==="playlist" && <LeftPanePlaylist Playlist={playlist}  setMessage={setMessage}  setPlaylist={setPlaylist} onDraw={onDraw} ></LeftPanePlaylist>}
                    {leftDisplay==="playlist_public" && <LeftPaneCommunityPlaylist Playlist={playlist}  setMessage={setMessage} setGeneralMessage={setGeneralMessage}  setPlaylist={setPlaylist} onDraw={onDraw} ></LeftPaneCommunityPlaylist>}
                    {leftDisplay==="playlist_member" && <LeftPaneCommunityPlaylist Playlist={playlist}  setMessage={setMessage} setGeneralMessage={setGeneralMessage}  setPlaylist={setPlaylist} onDraw={onDraw} ></LeftPaneCommunityPlaylist>}
                    {leftDisplay==="manage_member" && <LeftPaneCommunityPlaylist Playlist={playlist}  setMessage={setMessage} setGeneralMessage={setGeneralMessage}  setPlaylist={setPlaylist} onDraw={onDraw} ></LeftPaneCommunityPlaylist>}
                    
                    {centerDisplay==="changePwd" && <ChangePasswordDialog setCenterDisplay={setCenterDisplay}></ChangePasswordDialog>}

                     {centerDisplay==="manage_member" && <CenterPaneMemberManage Context={myContext} setPlaylist={setPlaylist} ></CenterPaneMemberManage> }

                    {centerDisplay==="playlist" && <CenterPanePlaylist Context={myContext} setPlaylist={setPlaylist}  user_id={user_id.current} ></CenterPanePlaylist> }
                    {centerDisplay==="playlist_public" && <CenterPanePlaylistCommunity Context={myContext} setPlaylist={setPlaylist} playlistClass='public'  user_id={user_id.current}></CenterPanePlaylistCommunity> }
                    {centerDisplay==="playlist_member" && <CenterPanePlaylistMember Context={myContext} setPlaylist={setPlaylist} playlistClass='member' user_id={user_id.current}></CenterPanePlaylistMember> }

                    {centerDisplay==="cloudlist" && <CenterPaneCloudlist Context={myContext} access_token={access_token} onClick={()=>{ 
                          // console.log('CenterPaneCloudlist Clicked..'); 
                         }}></CenterPaneCloudlist> }

                    <Suspense fallback={<Spinner/>}> 
                          {centerDisplay==="vrworld" &&  browserFlag && 
                             <CenterPaneVRWorld class_id={class_id.current} user_name={user_name.current} user_id={user_id.current} className='centerPane' 
                                     access_token={access_token} Message={message}  generalMessage={generalMessage} connectedUser={connectedUser} setConnectedUser={setConnectedUser} onDraw={onDraw} webCamMessage={webCamMessage} ></CenterPaneVRWorld> 
                          } 
                    </Suspense>
                    <RightPane setCenterDisplay={setCenterDisplay} access_token={access_token}  setMessage={setMessage} webCamMessage={webCamMessage} setLeftDisplay={setLeftDisplay} user_id={user_id.current}></RightPane>
                  </div>
                  <Footer></Footer>
            </div>}
          </UserContext.Provider>
    </div>
  );
}  //[leftDisplay, setLeftDisplay
export default App;
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/*
const sceneEl = document.querySelector('a-scene');
sceneEl.is('vr-mode')
sceneEl.exitVR()

const sceneEl = document.querySelector('a-scene');
if (sceneEl.is('vr-mode')) sceneEl.exitVR();


async function exitXR( renderer ) {
  const session = renderer.xr.getSession();
  if ( session !== null ) {
      await session.end();
    // execute optional code after WebXR shutdown
  }
}
*/